import apolloClient from 'core/apolloClient';
import { CALENDAR_LOOKUP } from './queries';
import { CALENDAR, PERIOD, RANGE } from 'lib/calendar/constants';

// doing this for existing implementation
const translate = (payload) => ({
  ...payload,
  c: CALENDAR[payload.c],
  p: PERIOD[payload.p],
  r: RANGE[payload.r],
});

// currently this is used in class based components
// sometimes it returns Full name (Ex. CUSTOM), lets clean it up in the future
const calendarLookup = async ({ verbose = false, ...dateRange }) => {
  const rangeType = RANGE[dateRange?.rangeType] || dateRange?.rangeType;
  const { data, loading, error } = await apolloClient.query({
    variables: {
      input: { dateRange: { ...dateRange, rangeType }, verbose },
    },
    query: CALENDAR_LOOKUP,
  });

  return {
    data: translate(data?.calendarLookup?.dateRange),
    loading,
    error,
  };
};

export default calendarLookup;
